import { apiClient } from '@/lib/apiClient';
import type {
  NotificationPageResponse,
  NotificationPreference,
  UpsertPreferencePayload,
} from './types';

const BASE = '/api/web/v1/notifications';

export async function listNotifications(
  params: { page?: number; size?: number } = {},
): Promise<NotificationPageResponse> {
  const res = await apiClient.get<NotificationPageResponse>(BASE, { params });
  return res.data;
}

export async function getUnreadCount(): Promise<number> {
  const res = await apiClient.get<{ count: number }>(`${BASE}/unread-count`);
  return res.data.count;
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiClient.post(`${BASE}/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<{ markedRead: number }> {
  const res = await apiClient.post<{ markedRead: number }>(`${BASE}/read-all`);
  return res.data;
}

export async function listPreferences(): Promise<NotificationPreference[]> {
  const res = await apiClient.get<NotificationPreference[]>(`${BASE}/preferences`);
  return res.data;
}

export async function upsertPreference(
  payload: UpsertPreferencePayload,
): Promise<NotificationPreference> {
  const res = await apiClient.put<NotificationPreference>(`${BASE}/preferences`, payload);
  return res.data;
}
